import { render, staticRenderFns } from "./BookReader.vue?vue&type=template&id=057a3e72&scoped=true&"
import script from "./BookReader.vue?vue&type=script&lang=js&"
export * from "./BookReader.vue?vue&type=script&lang=js&"
import style0 from "./BookReader.vue?vue&type=style&index=0&id=057a3e72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-2f6a8101d6/2/home/apps/.yarn/berry/cache/vue-loader-npm-15.10.1-3a0b6c19d2-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a3e72",
  null
  
)

export default component.exports